import cn from "classnames";
import { URLS } from "constant";
import { useNavigationHistory } from "context";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const METADATA_TABS = [
  { label: "Industry", value: "industry" },
  { label: "Service", value: "service" },
  { label: "Country", value: "country" },
  { label: "State", value: "state" },
  { label: "City", value: "city" },
  { label: "Property Type", value: "property-type" },
];

const Leftbar = () => {
  const { navigate } = useNavigationHistory();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<string | null>("industry");

  useEffect(() => {
    if (searchParams?.get("tab")) {
      setActiveTab(searchParams?.get("tab"));
    }
  }, [searchParams]);

  return (
    <div className="min-w-[280px] w-[280px] h-full relative bg-jll-surface-base-secondary overflow-y-auto">
      <div className="flex flex-row items-center justify-between px-10 mt-6">
        <p className="text-jll-text-base-subdued">View metadata management</p>
      </div>

      <div className="py-10 space-y-2 w-full">
        {METADATA_TABS.map((tab, idx) => (
          <div
            key={idx}
            className={cn(
              "text-jll-text-base-subdued pl-10 pr-6 py-3 cursor-pointer",
              {
                "!text-jll-text-base-default border-r border-r-jll-text-base-default":
                  activeTab === tab.value,
              }
            )}
            onClick={() => {
              navigate(`${URLS.METADATA.ROOT}?tab=${tab?.value}`);
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leftbar;
